var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_1770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50.0195C18.3696 50.0195 12.0107 47.3856 7.32233 42.6972C2.63392 38.0088 0 31.6499 0 25.0195C0 18.3891 2.63392 12.0303 7.32233 7.34186C12.0107 2.65345 18.3696 0.0195313 25 0.0195312C31.6304 0.0195312 37.9893 2.65345 42.6777 7.34186C47.3661 12.0303 50 18.3891 50 25.0195C50 31.6499 47.3661 38.0088 42.6777 42.6972C37.9893 47.3856 31.6304 50.0195 25 50.0195ZM25 45.0195C30.3043 45.0195 35.3914 42.9124 39.1421 39.1617C42.8929 35.4109 45 30.3239 45 25.0195C45 19.7152 42.8929 14.6281 39.1421 10.8774C35.3914 7.12667 30.3043 5.01953 25 5.01953C19.6957 5.01953 14.6086 7.12667 10.8579 10.8774C7.10714 14.6281 5 19.7152 5 25.0195C5 30.3239 7.10714 35.4109 10.8579 39.1617C14.6086 42.9124 19.6957 45.0195 25 45.0195ZM22.5 26.0445V10.0195H27.5V23.9945L37.375 33.8695L33.85 37.3945L22.5 26.0445Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_1770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a1ec7fe26e2dbd5985c460d53502d9c8.svg";
export { ForwardRef as ReactComponent };